import zip from 'hs-lodash/zip';
export function rounded(strings, ...variables) {
  return zip(strings, variables).map(([string, variable]) => [string, typeof variable === 'number' ? Math.round(variable) : variable]).flat().join('');
}